export enum OrderAdjustmentType {
    DISCOUNT = 'DISCOUNT',
    TIP = 'TIP',
    CHARGE = 'CHARGE',
    REFUND = 'REFUND'
}

export enum OrderPaymentType {
    CASH_AT_POS = 'CASH_AT_POS',
    CARD_AT_POS = 'CARD_AT_POS',
    GIFT_CARD_AT_POS = 'GIFT_CARD_AT_POS',
    OTHER_AT_POS = 'OTHER_AT_POS',
    APPLEPAY = 'APPLEPAY',
    GOOGLEPAY = 'GOOGLEPAY',
    CARD_ON_FILE = 'CARD_ON_FILE',
    // is this used? looks like not
    CARD_TENDERED = 'CARD_TENDERED',
    GIFT_CARD = 'GIFT_CARD',
    // a pepper terminal payment
    CARDHOLDER_PRESENT = 'CARDHOLDER_PRESENT',
    CASH = 'CASH',
    // deprecated values:
    CARD = 'CARD', // same as CARD_AT_POS
    OTHER = 'OTHER',
    APP = 'APP', // same as CARD_ON_FILE

    // no longer used
    PAY_BY_BANK = 'PAY_BY_BANK'
}

export enum OrderScenario {
    TAB = 'TAB',
    TABLE = 'TABLE',
    PAYATPOS = 'PAYATPOS',
    PREORDER = 'PREORDER', // we have treated this as TAKE_OUT for tax mapping
    ORDER_TO_TABLE = 'ORDER_TO_TABLE',
    DINE_IN = 'DINE_IN',
    TAKE_OUT = 'TAKE_OUT',
    DELIVERY = 'DELIVERY'
    // DRIVE_THRU ?
}

export function isOrderScenario(obj: any): obj is OrderScenario {
    return obj in OrderScenario;
}

// an order that stays open until paid off
export const openOrderScenarios = [OrderScenario.TAB, OrderScenario.TABLE] as const;
export type OpenOrderScenarioType = (typeof openOrderScenarios)[number];
export function isOpenOrderScenarioType(obj: OrderScenario): obj is OpenOrderScenarioType {
    return openOrderScenarios.includes(obj as any);
}

// an order that is paid on ordering (nb payatpos is unknown type - it is neither OpenOrder nor OrderAndPay)
export const orderAndPayScenarios = [OrderScenario.PREORDER, OrderScenario.ORDER_TO_TABLE, OrderScenario.DINE_IN, OrderScenario.TAKE_OUT, OrderScenario.DELIVERY] as const;
export type OrderAndPayScenarioType = (typeof orderAndPayScenarios)[number];
export function isOrderAndPayScenarioType(obj: OrderScenario): obj is OrderAndPayScenarioType {
    return orderAndPayScenarios.includes(obj as any);
}

// an order is collected by customer or delivery courier, rather than waiter service
export const orderCollectScenarios = [OrderScenario.PREORDER, OrderScenario.DINE_IN, OrderScenario.TAKE_OUT, OrderScenario.DELIVERY] as const;
export type OrderCollectScenarioType = (typeof orderCollectScenarios)[number];
export function isOrderCollectScenarioType(obj: OrderScenario): obj is OrderCollectScenarioType {
    return orderCollectScenarios.includes(obj as any);
}

export const orderServiceTypeMap: { [key in Exclude<OrderScenario, OrderScenario.PAYATPOS>]: 'TAKE_OUT' | 'DELIVERY' | 'DINE_IN' } = {
    // we can't map PAYATPOS to anything since it means an order not handled via a Pepper channel
    TAB: 'DINE_IN' as const,
    TABLE: 'DINE_IN' as const,
    PREORDER: 'TAKE_OUT' as const,
    ORDER_TO_TABLE: 'DINE_IN' as const,
    DINE_IN: 'DINE_IN' as const,
    TAKE_OUT: 'TAKE_OUT' as const,
    DELIVERY: 'DELIVERY' as const
};

// when scenario is used as a key to mapped settings, the values used are the old subset at the moment.  Map the new values into the most appropriate old value
export type OrderScenarioV1 = OrderScenario.TAB | OrderScenario.TABLE | OrderScenario.PAYATPOS | OrderScenario.PREORDER | OrderScenario.ORDER_TO_TABLE;
export const orderScenarioV1Map: { [key in OrderScenario]: OrderScenarioV1 } = {
    TAB: OrderScenario.TAB as const,
    TABLE: OrderScenario.TABLE as const,
    PAYATPOS: OrderScenario.PAYATPOS as const,
    PREORDER: OrderScenario.PREORDER as const,
    ORDER_TO_TABLE: OrderScenario.ORDER_TO_TABLE as const,
    DINE_IN: OrderScenario.PREORDER as const,
    TAKE_OUT: OrderScenario.PREORDER as const,
    DELIVERY: OrderScenario.PREORDER as const
};

export enum PointOfSaleProvider {
    REVEL = 'REVEL',
    PEPPER = 'PEPPER',
    IBS = 'IBS',
    LAVU = 'LAVU',
    POINTONE = 'POINTONE',
    SQUARE = 'SQUARE',
    LIGHTSPEED = 'LIGHTSPEED',
    NOBLY = 'NOBLY',
    OMNIVORE_MICROS_SIMPHONY = 'OMNIVORE_MICROS_SIMPHONY',
    OMNIVORE_MICROS_3700 = 'OMNIVORE_MICROS_3700',
    OMNIVORE_NCR_ALOHA = 'OMNIVORE_NCR_ALOHA',
    COMTREX = 'COMTREX',
    ZONAL_AZTEC = 'ZONAL_AZTEC',
    DELIVERECT = 'DELIVERECT',
    GOODTILL = 'GOODTILL',
    TEVALIS = 'TEVALIS',
    NONE = 'NONE'
}
